export default {
  mcInboundEdit: {
    entryListStatus: {
      inboundNo: '委托加工入库单号',
      inboundCreatePersonNo: '制单人',
      inboundCreateDate: '制单日期',
      inboundCompanyCode: '公司',
      inboundStatus: '委托加工入库单状态',
      accountingStatus: '财务入库状态',
      isWriteOff: '是否已冲销',
      defaultPlaceholder: '自动生成',
    },
    baseInfo: {
      currencyTypeCode: '币种',
      inboundDate: '商品入库日期',
      inboundQuantity: '商品入库数量',
      distributionInboundNo: '物流入库单号',
      instructionNo: '供应商发货指令号',
      productDesc: '商品描述',
      productNo: '商品编码',
      settlementPrice: '商品结算价',
      settlementAmount: '商品总金额',
      partnerNo: '供应商',
      businessPersonNo: '业务员',
      inboundDepartmentCode: '部门',
      inboundStorageNo: '商品入库仓库',
      outboundStorageNo: '原材料出库仓库',

      defaultPlaceholder: '自动生成',
      inboundDatePlaceholder: '请选择日期',
      inboundQuantityPlaceholder: '请输入商品入库数量',
      distributionInboundNoPlaceholder: '请输入物流入库单号',
      instructionNoPlaceholder: '请输入供应商发货指令号',
      inboundDepartmentCodePlaceholder: '请选择部门',
      inboundStorageNoPlaceholder: '请选择入库仓库',
      outboundStorageNoPlaceholder: '请选择出库仓库',
      settlementPricePlaceholder: '请输入商品结算价',
      settlementAmountPlaceholder: '请输入商品总金额',
    },
    column: {
      sortNo: '序号',
      contractDetailNo: '合同行项目号',
      customerReceiveQuantity: '实收数量',
      distributionInboundNo: '物流入库单号',
      instructionNo: '供应商发货指令号',
      productDesc: '原材料描述',
      productNo: '原材料编码',
      ladingAmount: '原材料金额',
      ladingPrice: '原材料单位金额',
      ladingQuantity: '原材料数量',
      actualSendQuantity: '实发数量',
      ladingUnit: '计量单位',
      overShippedPercentage: '溢装比例',
      shortShippedPercentage: '短装比例',
      outboundStorageNo: '出库仓库',
      isCompleteDelivery: '是否完全发货',
      ladingPricePlaceholder: '请输入原材料单位金额',
      ladingQuantityPlaceholder: '请输入原材料数量',
      actualSendQuantityPlaceholder: '请输入实发数量',
    },
    costInfo: {
      // distributionInboundNo:'物流入库单号',
      instructionNo: '供应商发货指令号',
      productDesc: '产成品描述',
      productNo: '产成品编码',
      contractQuantity: '合同数量',
      productUnit: '单位',
      businessContractPrice: '加工费单价',
      distributionInboundNo: '商品物流入库单号',
      contractNo: '委托加工采购合同号',
      contractDetailNo: '委托加工采购合同行号',
      externalContractNo: '委托加工外部合同号',
      instructionDetailNo: '供应商发货指令行号',
      contractType: '合同类型',
      productAmountWithTax: '含税产成品总金额',
      productAmountWithTaxPlaceholder: '请输入含税产成品总金额',
      inboundBatchNo: '产成品业务入库批次号',
      inboundQuantity: '产成品入库数量',
      settlementPrice: '不含税产成品结算价',
      settlementAmount: '不含税产成品总金额',
      mcAmountWithTax: '含税加工费总金额',
      productTaxRate: '产成品税率',
      taxRate: '加工费税率',
      taxCode: '税率', //通过税码查询税率
      mcTaxWithout: '加工费税额',
      productTaxAmount: '产成品税额',
      mcAmountWithoutTax: '不含税加工费总金额',
      ddd: '单位加工费',
      materialAmount: '原材料总金额',
      inboundQuantityPlaceholder: '请输入产成品入库数量',
      settlementPricePlaceholder: '请输入商品结算价',
      mcAmountWithTaxPlaceholder: '请输入含税加工费',
      businessContractPricePlaceholder: '请输入加工费单价',
    },
    title: {
      entryListStatus: '委托加工入库单状态',
      baseInfo: '基本信息',
      costInfo: '费用明细',
      row: '原材料行明细',
      pickingTab: '拣配结果',
    },
    btns: {
      generatePaymentDocument: '生成付款申请单',
      save: '保存',
      edit: '编辑',
      submission: '提交',
      withdraw: '撤销',
      delete: '删除',
      printing: '打印',
      return: '退回',
      accountEntry: '生成凭证',
      writeOff: '冲销',
      doSyncVoucherForEntityData: '过账凭证',
    },
    confirm: {
      withdraw: {
        title: '撤销单据？',
        content: '是否撤销单据？',
      },
      // returned:{
      //     title:"退回单据？",
      //     content:"是否退回单据？"
      // },
      // toleranceCheck:{
      //     title:"允差校验",
      //     content:"发票超过允差范围，请确认发票填写是否无误？"
      // }
    },
    msg: {
      rules: {
        input: '请填写',
        select: '请选择',
      },
    },
  },
};
